import {fetchJson} from '../../../Library/Fetch';

const DEBOUNCE_MS = 250;

const searchUrl = (select, query) => {
    const url = new URL(select.searchUrl, window.location.origin);
    url.searchParams.set('query', query);

    return url.toString();
};

/** @param {HTMLElement} select an enhanced od-select carrying a `search-url` attribute */
export const bindRemoteSearch = select => {
    const preloaded      = select.currentOptions();
    const noResultsLabel = select.getAttribute('no-results-label') ?? '';
    let timer   = null;
    let request = null;

    const search = async query => {
        const token = Symbol('search');
        request = token;
        select.classList.add('is-searching');

        const payload = await fetchJson(searchUrl(select, query));

        if (request !== token) {
            return;
        }

        select.classList.remove('is-searching');

        if (payload === null) {
            return;
        }

        select.replaceOptions(payload.options.map(option => new Option(option.label, String(option.value))), noResultsLabel);
    };

    select.searchInput.addEventListener('input', event => {
        clearTimeout(timer);
        request = null;
        select.classList.remove('is-searching');

        const query = event.target.value.trim();

        if (query === '') {
            select.replaceOptions(preloaded);

            return;
        }

        timer = setTimeout(() => search(query), DEBOUNCE_MS);
    });
};
